function numOrZero(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
}

function formatConditionSummary(condition = {}) {
    const conditionText = condition.conditionText || "条件";
    const conditionMode = condition.conditionMode === "composite" ? "composite" : "single";
    const operator = condition.operator === "OR" ? "OR" : "AND";
    const entries = Array.isArray(condition.conditions) ? condition.conditions : [];
    const entryText = entries
        .map((entry) => String(entry?.label || entry?.expression || "").trim())
        .filter(Boolean)
        .join(" / ");
    const detail =
        conditionMode === "composite"
            ? `[${operator} ${entries.length || 0}条件${entryText ? `: ${entryText}` : ""}]`
            : "";
    return `条件「${conditionText}」${detail}: ${condition.trueLabel || "ON"} / ${condition.falseLabel || "OFF"} / ${(condition.timeoutLabel || "TIMEOUT")} ${condition.timeoutSec ?? 0}s`;
}

function formatButtonSummary(button = {}) {
    const label = button.label || button.name || "押しボタン";
    const signalName = button.signalName || "-";
    const modeLabel = button.mode === "alternate" ? "alternate" : "momentary";
    return `ボタン「${label}」(${signalName}) は ${modeLabel}: ${button.trueLabel || "ON"} / ${button.falseLabel || "OFF"}`;
}

function formatSignalOutputSummary(node = {}) {
    const label = node.label || node.name || "信号出力";
    const signalName = node.signalName || "-";
    const action = node.action || "ON";
    return `信号出力「${label}」: ${signalName} -> ${action}`;
}

export function buildFlowSummaryFromContext(context = {}) {
    const lines = [];
    const flowNodes = Array.isArray(context.flowNodes) ? context.flowNodes : [];
    const axes = Array.isArray(context.axes) ? context.axes : [];
    const conditions = Array.isArray(context.conditions) ? context.conditions : [];
    const errors = Array.isArray(context.errors) ? context.errors : [];
    const buttons = flowNodes.filter((node) => node.type === "button");
    const signalOutputs = flowNodes.filter((node) => node.type === "signal_output");

    const startNodes = flowNodes.filter(node => node.type === "start");
    if (startNodes.length) {
        lines.push(startNodes.map(node => `開始ノード「${node.name || "開始"}」`).join("、") + " があります。");
    }

    for (const axis of axes) {
        const motions = Array.isArray(axis.motions) ? axis.motions : [];
        if (!motions.length) continue;
        lines.push(`${axis.name} は ${motions.length} 動作です。`);
        for (const motion of motions) {
            const parts = [];
            if (motion.dependency?.sourceMotionName) {
                const sourceAxisName = motion.dependency.sourceAxisName || "上流軸";
                parts.push(`${sourceAxisName}/${motion.dependency.sourceMotionName} 完了後 + ${numOrZero(motion.dependency.offsetSec).toFixed(2)}s`);
            } else {
                parts.push(`絶対開始 ${numOrZero(motion.absoluteStartSec).toFixed(2)}s`);
            }
            if (motion.startConditionText) parts.push(`条件 ${motion.startConditionText}`);
            parts.push(`距離 ${motion.distance ?? "-"} ${axis.units?.distance || "-"}`);
            parts.push(`最高速度 ${motion.maxSpeed ?? "-"} ${axis.units?.speed || "-"}`);
            if (numOrZero(motion.waitTime) > 0) parts.push(`待機 ${numOrZero(motion.waitTime).toFixed(2)}s`);
            lines.push(`- ${axis.name}/${motion.name}: ${parts.join(" / ")}`);
        }
    }

    if (conditions.length) {
        lines.push(...conditions.map((condition) => formatConditionSummary(condition)));
    }

    if (buttons.length) {
        lines.push(...buttons.map((button) => formatButtonSummary(button)));
    }

    if (signalOutputs.length) {
        lines.push(...signalOutputs.map((node) => formatSignalOutputSummary(node)));
    }

    if (errors.length) {
        lines.push(...errors.map(error => `エラー ${error.errorCode || "E001"}: ${error.errorMessage || "エラー"}`));
    }

    return lines.join("\n");
}
